import { Component } from '@angular/core';

@Component({
  selector: 'app-servicespage-hero',
  templateUrl: './servicespage-hero.component.html',
  styleUrls: ['./servicespage-hero.component.scss']
})
export class ServicespageHeroComponent {

}
